import React from "react";

type AccountingPlaceholderProps = {
  title: string;
  description?: string;
};

const AccountingPlaceholder: React.FC<AccountingPlaceholderProps> = ({
  title,
  description,
}) => (
  <div className="p-6 space-y-2">
    <h1 className="text-2xl font-semibold text-gray-800">{title}</h1>
    <p className="text-gray-600">
      {description || "Tính năng đang được phát triển."}
    </p>
  </div>
);

export default AccountingPlaceholder;
